module.exports = __webpack_public_path__ + "img/DEM_Black_PNG.37134687.png";